export function getLan(params = {}) {
    let isSet = false;
    let isEn = true;
  
    if(params.lang) {
        if(params.lang === "en"){
            isSet = true;
        }
        if(params.lang === "fa"){
            isSet = true;
            isEn = false
        }
    }
    return {isEn, isSet};
} 

export function getLanLoc(path = "") {
    let isSet = false;
    let isEn = true;
    if(path.length >= 3) {
        let cutted = path.substring(1, 3);
        if(cutted === "en"){
            isSet = true;
        }
        if(cutted === "fa"){
            isSet = true;
            isEn = false
        }
    }
    return {isEn, isSet};
} 